import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import  {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { OportunitatsService } from '../oportunitats.service';
import { ListOportunitatsService } from '../list.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mcrit-gestio-oportunitats-filters',
  templateUrl: 'oportunitats-filters.component.html',
  styleUrls: ['oportunitats-filters.component.css'],
  providers: []
})
export class OportunitatsFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(public translate: TranslateService, private listOportunitatsService: ListOportunitatsService,private oportunitatsService: OportunitatsService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listOportunitatsService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listOportunitatsService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listOportunitatsService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    this.listOportunitatsService.valFiltres={};

    this.filterModel = { stateDataPost: true };
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
    this.filterModel = this.validFilters.reduce((acum, curr) => {
        curr.inputs.forEach(inputGroup => {
          switch (inputGroup.type) {
            case 'select':
              acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
              break;
            default:
            inputGroup.values.forEach(input => {
              if (input.autocomplete) { }
              acum[input.name] = (input.value ? input.value : null);
              if(input.autocomplete)requestedAutocompletes.push(input.autocomplete);
                acum[input.name] = (input.value ? input.value : null);
              });
          }
        });

      return acum;
    }, {});
   
    this.dataLists = requestedAutocompletes.map(id => { return { id: id, options: this.listOportunitatsService.getAutocomplete(id) }; });

    this.sendActiveFilters();
  }
}
